import { mountJiraIssuesListApp } from '~/issues/list';
import { initWorkItemsRoot } from '~/work_items';

mountJiraIssuesListApp();
initWorkItemsRoot();
